import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading, petitionSlugCanonicalRedirect } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'starter-dashboard-v2',
		path: ['/p/:slug/dashboard-v2', '/p/:slug/dashboard-v2/:section'],
		component: loadable(async () => import(/* webpackChunkName: "pages/starter_dashboard_v2" */ './index'), {
			exportName: 'StarterDashboardV2',
			fallback: Loading,
		}),
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		frame: true,
		restrictedAccess: {
			nonGuestOnly: true,
			role: ['staff'],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
		disableFullRerenderForParams: ['section'],
	},
];
